<template>
  <v-container class="mt-4 px-4" fluid>
    <v-card class="shadowCard">
      <v-card-title class="text-subtitle-1">
        Telefonía / CDR
        <v-spacer />
        <v-btn small dark color="teal" tile class="mr-2" @click="dialogSucursalOrigen = true">
          <v-icon small left>mdi-map-marker-account</v-icon>
          Sucursal origen
        </v-btn>
        <v-btn
          small
          dark
          tile
          class="mr-2"
          :color="vistaReporteLlamadas ? 'deep-purple' : 'indigo'"
          :loading="cargarAsignacionesReporte"
          @click="toggleReporteLlamadas"
        >
          <v-icon small left>{{ vistaReporteLlamadas ? 'mdi-table' : 'mdi-podium' }}</v-icon>
          {{ vistaReporteLlamadas ? 'Ver tabla CDR' : 'Reporte de llamadas' }}
        </v-btn>
        <v-btn small dark color="primary" tile @click="recargarPestañaActual">
          <v-icon small left>mdi-refresh</v-icon>
          Actualizar pestaña
        </v-btn>
      </v-card-title>

      <v-row class="px-4 pb-2 pt-1" align="end" dense>
        <v-col cols="12" sm="6" md="4">
          <v-select
            v-model="escuelaSeleccionada"
            :items="opcionesEscuela"
            label="Escuela"
            item-text="text"
            item-value="value"
            filled
            dense
            hide-details
          />
        </v-col>
        <v-col cols="12" sm="6" md="5">
          <v-autocomplete
            v-model="idPlantelSeleccionado"
            :items="plantelesFiltradosPorEscuela"
            label="Plantel (sucursal CDR)"
            item-text="plantel"
            item-value="id_plantel"
            clearable
            filled
            dense
            hide-details
            :loading="cargarPlanteles"
            no-data-text="Sin planteles para esta escuela"
          />
        </v-col>
      </v-row>

      <v-tabs v-model="tab" background-color="transparent" grow show-arrows>
        <v-tab>CDR</v-tab>
        <v-tab>Estadísticas</v-tab>
        <v-tab>Extensiones</v-tab>
        <v-tab>Estado del sistema</v-tab>
      </v-tabs>

      <v-divider />

      <v-card-text class="pt-4">
        <!-- CDR -->
        <div v-show="tab === 0">
          <v-row align="end">
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="filtros.startDate"
                label="Fecha inicio"
                type="date"
                filled
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="filtros.endDate"
                label="Fecha fin"
                type="date"
                filled
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-btn color="orange" dark block tile :loading="cargarCdr" @click="cargarCdrLista">
                <v-icon small left>mdi-magnify</v-icon>
                Consultar
              </v-btn>
            </v-col>
            <v-col v-if="cdrMetaHint" cols="12" class="pt-0">
              <div class="text-caption grey--text">{{ cdrMetaHint }}</div>
            </v-col>
          </v-row>
          <v-sheet
            v-if="!vistaReporteLlamadas"
            rounded
            class="mt-3 pa-4 telefonia-filtros-vista"
            elevation="0"
            color="grey lighten-4"
          >
            <div class="text-overline grey--text text--darken-1 mb-3">Filtros sobre el resultado</div>
            <v-row dense align="stretch">
              <v-col cols="12" md="6">
                <div class="d-flex align-center mb-2">
                  <v-avatar size="28" color="blue-grey lighten-3" class="mr-2">
                    <v-icon small color="blue-grey darken-2">mdi-phone-log</v-icon>
                  </v-avatar>
                  <span class="subtitle-2 font-weight-medium">Disposition</span>
                </div>
                <div class="telefonia-filtros-chips d-flex flex-wrap align-center">
                  <v-chip
                    small
                    class="ma-1 font-weight-medium"
                    :color="filtrosVistaCdr.disposition == null ? 'primary' : undefined"
                    :outlined="filtrosVistaCdr.disposition != null"
                    @click="filtrosVistaCdr.disposition = null"
                  >
                    <v-icon left small>mdi-filter-off-outline</v-icon>
                    Todos
                  </v-chip>
                  <v-chip
                    v-for="d in opcionesDispositionCdr"
                    :key="'disp-' + d"
                    small
                    class="ma-1 font-weight-medium text-uppercase"
                    :color="filtrosVistaCdr.disposition === d ? colorChipDisposition(d) : undefined"
                    :outlined="filtrosVistaCdr.disposition !== d"
                    :dark="filtrosVistaCdr.disposition === d"
                    @click="filtrosVistaCdr.disposition = d"
                  >
                    <v-icon left small>{{ iconoDisposition(d) }}</v-icon>
                    {{ d }}
                  </v-chip>
                  <span
                    v-if="!opcionesDispositionCdr.length && !cargarCdr"
                    class="text-caption grey--text px-1"
                  >Sin valores (consulta CDR primero)</span>
                </div>
              </v-col>
              <v-col cols="12" md="6" class="telefonia-filtro-sentido-col">
                <div class="d-flex align-center mb-2">
                  <v-avatar size="28" color="teal lighten-4" class="mr-2">
                    <v-icon small color="teal darken-2">mdi-swap-vertical</v-icon>
                  </v-avatar>
                  <span class="subtitle-2 font-weight-medium">Sentido</span>
                </div>
                <div class="telefonia-filtros-chips d-flex flex-wrap align-center">
                  <v-chip
                    small
                    class="ma-1 font-weight-medium"
                    :color="filtrosVistaCdr.sentido == null ? 'primary' : undefined"
                    :outlined="filtrosVistaCdr.sentido != null"
                    @click="filtrosVistaCdr.sentido = null"
                  >
                    <v-icon left small>mdi-filter-off-outline</v-icon>
                    Todos
                  </v-chip>
                  <v-chip
                    small
                    class="ma-1 font-weight-medium"
                    :color="filtrosVistaCdr.sentido === 'inbound' ? 'teal' : undefined"
                    :outlined="filtrosVistaCdr.sentido !== 'inbound'"
                    :dark="filtrosVistaCdr.sentido === 'inbound'"
                    @click="filtrosVistaCdr.sentido = 'inbound'"
                  >
                    <v-icon left small>mdi-phone-incoming</v-icon>
                    Inbound
                  </v-chip>
                  <v-chip
                    small
                    class="ma-1 font-weight-medium"
                    :color="filtrosVistaCdr.sentido === 'outbound' ? 'deep-orange' : undefined"
                    :outlined="filtrosVistaCdr.sentido !== 'outbound'"
                    :dark="filtrosVistaCdr.sentido === 'outbound'"
                    @click="filtrosVistaCdr.sentido = 'outbound'"
                  >
                    <v-icon left small>mdi-phone-outgoing</v-icon>
                    Outbound
                  </v-chip>
                </div>
              </v-col>
            </v-row>
          </v-sheet>

          <v-alert v-if="cdrError" type="error" dense outlined class="mt-3">{{ cdrError }}</v-alert>

          <v-row v-if="cdrRecords.length && !vistaReporteLlamadas" class="mt-2">
            <v-col cols="6" sm="4" md="2">
              <v-sheet rounded class="pa-3 text-center" color="blue-grey lighten-5">
                <div class="text-caption">Total</div>
                <div class="text-h6">{{ statsCdrVista.total }}</div>
              </v-sheet>
            </v-col>
            <v-col cols="6" sm="4" md="2">
              <v-sheet rounded class="pa-3 text-center" color="teal lighten-5">
                <div class="text-caption">Entrantes</div>
                <div class="text-h6">{{ statsCdrVista.entrantes }}</div>
              </v-sheet>
            </v-col>
            <v-col cols="6" sm="4" md="2">
              <v-sheet rounded class="pa-3 text-center" color="cyan lighten-5">
                <div class="text-caption">Salientes</div>
                <div class="text-h6">{{ statsCdrVista.salientes }}</div>
              </v-sheet>
            </v-col>
            <v-col cols="6" sm="4" md="2">
              <v-sheet rounded class="pa-3 text-center" color="green lighten-5">
                <div class="text-caption">Contestadas</div>
                <div class="text-h6">{{ statsCdrVista.contestadas }}</div>
              </v-sheet>
            </v-col>
            <v-col cols="6" sm="4" md="2">
              <v-sheet rounded class="pa-3 text-center" color="amber lighten-5">
                <div class="text-caption">No contestadas</div>
                <div class="text-h6">{{ statsCdrVista.noContestadas }}</div>
              </v-sheet>
            </v-col>
            <v-col cols="6" sm="4" md="2">
              <v-sheet rounded class="pa-3 text-center" color="indigo lighten-5">
                <div class="text-caption">Duración prom.</div>
                <div class="text-h6">
                  {{ statsCdrVista.duracionPromedio != null ? statsCdrVista.duracionPromedio.toFixed(2) : '—' }}
                </div>
              </v-sheet>
            </v-col>
          </v-row>

          <div
            v-if="cdrRecords.length"
            class="d-flex flex-wrap align-center mt-2"
          >
            <div class="text-caption grey--text mr-3">
              Muestra: {{ statsCdrVista.muestra }} registros
              <span v-if="vistaReporteLlamadas" class="ml-1 indigo--text font-weight-medium">
                · Vista: reporte de llamadas
              </span>
            </div>
            <v-btn
              small
              dark
              tile
              :color="vistaReporteLlamadas ? 'deep-purple' : 'indigo'"
              :loading="cargarAsignacionesReporte"
              @click="toggleReporteLlamadas"
            >
              <v-icon small left>{{ vistaReporteLlamadas ? 'mdi-table' : 'mdi-podium' }}</v-icon>
              {{ vistaReporteLlamadas ? 'Ver tabla CDR' : 'Reporte de llamadas' }}
            </v-btn>
          </div>

          <!-- Tabla CDR normal -->
          <v-data-table
            v-if="!vistaReporteLlamadas"
            class="elevation-0 mt-4 shadowCard"
            dense
            :headers="headersCdr"
            :items="cdrRecordsFiltrados"
            :loading="cargarCdr"
          >
            <template v-slot:item.disposition="{ item }">
              <v-chip
                v-if="item.disposition != null && item.disposition !== ''"
                dark
                small
                class="text-caption font-weight-medium"
                :color="colorChipDisposition(item.disposition)"
              >
                {{ item.disposition }}
              </v-chip>
              <span v-else class="grey--text text-caption">—</span>
            </template>

            <template v-slot:item.userfield="{ item }">
              <v-chip
                v-if="etiquetaSentido(item.userfield)"
                outlined
                small
                class="text-caption px-2"
                :color="colorChipSentido(item.userfield)"
              >
                {{ etiquetaSentido(item.userfield) }}
              </v-chip>
              <span v-else class="grey--text text-caption">—</span>
            </template>

            <template v-slot:item.recordfiles="{ item }">
              <CdrRecordingPlayer
                :recordfiles="item.recordfiles"
                :uniqueid="item.uniqueid"
                :sucursal="item.sucursal || item.sucursal_nombre || item.nombre_sucursal || item.branch || null"
              />
            </template>

            <template v-slot:no-data>
              <div class="grey--text py-4 text-center">Sin datos. Ajusta filtros y consulta.</div>
            </template>
          </v-data-table>

          <!-- Ranking reporte de llamadas -->
          <v-data-table
            v-else
            class="elevation-0 mt-4 shadowCard"
            dense
            item-key="posicion"
            :headers="headersReporteLlamadas"
            :items="reporteLlamadasRows"
            :loading="cargarCdr || cargarAsignacionesReporte"
          >
            <template v-slot:item.posicion="{ item }">
              <v-chip
                small
                dark
                :color="item.posicion <= 3 ? 'amber darken-2' : 'blue-grey'"
                class="font-weight-bold"
              >
                {{ item.posicion }}
              </v-chip>
            </template>

            <template v-slot:item.vendedora="{ item }">
              <button
                type="button"
                class="telefonia-link-vendedora"
                @click="abrirModalReporteVendedora(item)"
              >
                {{ item.vendedora }}
              </button>
            </template>

            <template v-slot:item.totalLlamadas="{ item }">
              <button
                type="button"
                class="telefonia-btn-pill telefonia-btn-pill--total"
                @click="abrirModalReporte(item, 'total')"
              >
                {{ item.totalLlamadas }}
              </button>
            </template>

            <template v-slot:item.llamadasReales="{ item }">
              <button
                type="button"
                class="telefonia-btn-pill telefonia-btn-pill--reales"
                @click="abrirModalReporte(item, 'reales')"
              >
                {{ item.llamadasReales }}
              </button>
            </template>

            <template v-slot:item.llamadasIntencion="{ item }">
              <button
                type="button"
                class="telefonia-btn-pill telefonia-btn-pill--intencion"
                @click="abrirModalReporte(item, 'intencion')"
              >
                {{ item.llamadasIntencion }}
              </button>
            </template>

            <template v-slot:no-data>
              <div class="grey--text py-4 text-center">
                No hay filas para el reporte. Consulta CDR y asigna responsables en «Sucursal origen».
              </div>
            </template>
          </v-data-table>

          <v-expansion-panels v-if="cdrRaw != null" class="mt-2" flat>
            <v-expansion-panel>
              <v-expansion-panel-header class="text-caption">Respuesta raw (debug)</v-expansion-panel-header>
              <v-expansion-panel-content>
                <pre class="text-caption" style="white-space: pre-wrap; max-height: 240px; overflow: auto">{{ cdrRawStr }}</pre>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>

        <!-- Estadísticas -->
        <div v-show="tab === 1">
          <v-row align="end">
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="filtrosStats.startDate"
                label="Fecha inicio"
                type="date"
                filled
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="filtrosStats.endDate"
                label="Fecha fin"
                type="date"
                filled
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <v-text-field
                v-model.number="filtrosStats.numRecords"
                label="Registros (muestra)"
                type="number"
                min="1"
                filled
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <v-text-field
                v-model.number="filtrosStats.page"
                label="Página"
                type="number"
                min="1"
                filled
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-btn color="orange" dark block tile :loading="cargarStats" @click="cargarEstadisticas">
                Consultar
              </v-btn>
            </v-col>
          </v-row>

          <v-alert v-if="statsError" type="error" dense outlined class="mt-3">{{ statsError }}</v-alert>

          <v-row v-if="stats" class="mt-2">
            <v-col cols="6" sm="4" md="2">
              <v-sheet rounded class="pa-3 text-center" color="blue-grey lighten-5">
                <div class="text-caption">Total</div>
                <div class="text-h6">{{ stats.total != null ? stats.total : '—' }}</div>
              </v-sheet>
            </v-col>
            <v-col cols="6" sm="4" md="2">
              <v-sheet rounded class="pa-3 text-center" color="teal lighten-5">
                <div class="text-caption">Entrantes</div>
                <div class="text-h6">{{ stats.entrantes != null ? stats.entrantes : '—' }}</div>
              </v-sheet>
            </v-col>
            <v-col cols="6" sm="4" md="2">
              <v-sheet rounded class="pa-3 text-center" color="cyan lighten-5">
                <div class="text-caption">Salientes</div>
                <div class="text-h6">{{ stats.salientes != null ? stats.salientes : '—' }}</div>
              </v-sheet>
            </v-col>
            <v-col cols="6" sm="4" md="2">
              <v-sheet rounded class="pa-3 text-center" color="green lighten-5">
                <div class="text-caption">Contestadas</div>
                <div class="text-h6">{{ stats.contestadas != null ? stats.contestadas : '—' }}</div>
              </v-sheet>
            </v-col>
            <v-col cols="6" sm="4" md="2">
              <v-sheet rounded class="pa-3 text-center" color="amber lighten-5">
                <div class="text-caption">No contestadas</div>
                <div class="text-h6">{{ stats.noContestadas != null ? stats.noContestadas : '—' }}</div>
              </v-sheet>
            </v-col>
            <v-col cols="6" sm="4" md="2">
              <v-sheet rounded class="pa-3 text-center" color="indigo lighten-5">
                <div class="text-caption">Duración prom.</div>
                <div class="text-h6">{{ stats.duracionPromedio != null ? stats.duracionPromedio.toFixed(2) : '—' }}</div>
              </v-sheet>
            </v-col>
          </v-row>

          <div v-if="sampleSize != null" class="text-caption grey--text mt-2">Muestra: {{ sampleSize }} registros</div>

          <v-card v-if="topExtensiones.length" outlined class="mt-4">
            <v-card-subtitle class="pb-0 font-weight-medium">Top extensiones</v-card-subtitle>
            <v-card-text>
              <v-simple-table dense>
                <thead>
                  <tr>
                    <th class="text-left">Extensión</th>
                    <th class="text-right">Llamadas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, idx) in topExtensiones" :key="'ext-' + idx">
                    <td>{{ row.extension }}</td>
                    <td class="text-right">{{ row.count }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </div>

        <!-- Extensiones -->
        <div v-show="tab === 2">
          <v-alert v-if="extError" type="error" dense outlined class="mb-3">{{ extError }}</v-alert>
          <v-btn color="primary" small dark tile class="mb-3" :loading="cargarExt" @click="cargarExtensionesLista">
            Cargar extensiones
          </v-btn>
          <pre v-if="extensionsJson" class="text-caption pa-3" style="background:#f5f5f5;border-radius:4px;max-height:480px;overflow:auto">{{ extensionsJson }}</pre>
          <div v-else-if="!cargarExt" class="grey--text text-caption">Pulsa «Cargar extensiones».</div>
        </div>

        <!-- Estado -->
        <div v-show="tab === 3">
          <v-alert v-if="statusError" type="error" dense outlined class="mb-3">{{ statusError }}</v-alert>
          <v-btn color="primary" small dark tile class="mb-3" :loading="cargarStatus" @click="cargarEstadoSistema">
            Consultar estado
          </v-btn>
          <pre v-if="statusJson" class="text-caption pa-3" style="background:#f5f5f5;border-radius:4px;max-height:480px;overflow:auto">{{ statusJson }}</pre>
          <div v-else-if="!cargarStatus" class="grey--text text-caption">Pulsa «Consultar estado».</div>
        </div>
      </v-card-text>
    </v-card>

    <DialogSucursalOrigen
      v-model="dialogSucursalOrigen"
      :cdr-records="cdrRecords"
      @success="onSucursalOrigenSuccess"
    />

    <!-- Resumen IA por vendedora -->
    <v-dialog v-model="dialogReporteVendedora" max-width="520" scrollable>
      <v-card v-if="reporteVendedoraItem" class="ia-vendedora-card">
        <div class="ia-vendedora-header px-4 py-3 white--text">
          <div class="text-h6 font-weight-bold">Reporte por vendedora</div>
          <div class="caption" style="opacity: 0.92">{{ periodoReporteLabel }}</div>
        </div>

        <v-card-text class="pt-4 px-4">
          <div class="d-flex align-start justify-space-between mb-4">
            <div>
              <div class="text-h5 font-weight-bold">{{ reporteVendedoraItem.vendedora }}</div>
              <div class="caption grey--text text--darken-1 mt-1">
                {{ resumenVendedoraActual.totalAnalizadas }}
                {{ resumenVendedoraActual.totalAnalizadas === 1 ? 'llamada analizada' : 'llamadas analizadas' }}
              </div>
            </div>
            <div
              v-if="resumenVendedoraActual.totalAnalizadas"
              class="ia-promedio-badge text-center white--text"
              :style="{ backgroundColor: colorPromedioHex(resumenVendedoraActual.promedio) }"
            >
              <div class="ia-promedio-num">{{ resumenVendedoraActual.promedio }}</div>
              <div class="ia-promedio-label">prom.</div>
            </div>
            <div v-else class="ia-promedio-badge ia-promedio-badge--empty text-center grey--text">
              <div class="ia-promedio-num">—</div>
              <div class="ia-promedio-label">prom.</div>
            </div>
          </div>

          <template v-if="resumenVendedoraActual.totalAnalizadas">
            <div class="subtitle-2 font-weight-bold mb-2">Puntos a mejorar</div>
            <div v-if="resumenVendedoraActual.puntosMejora.length">
              <div
                v-for="(punto, idx) in resumenVendedoraActual.puntosMejora"
                :key="'mejora-' + idx"
                class="ia-punto-mejora mb-2"
              >
                {{ punto.texto }}
                <span v-if="punto.count > 1" class="caption grey--text"> ({{ punto.count }}×)</span>
              </div>
            </div>
            <div v-else class="caption grey--text mb-4">
              Sin áreas de mejora detectadas en las retroalimentaciones.
            </div>

            <v-divider class="my-4" />

            <div class="subtitle-2 font-weight-bold mb-3">Llamadas por resultado</div>

            <div class="mb-3">
              <div class="d-flex justify-space-between body-2 mb-1">
                <span>Visto bueno ({{ resumenVendedoraActual.vistoBueno }})</span>
                <span class="font-weight-medium">{{ resumenVendedoraActual.pctVistoBueno }}%</span>
              </div>
              <v-progress-linear
                :value="resumenVendedoraActual.pctVistoBueno"
                height="12"
                rounded
                color="success"
                background-color="grey lighten-3"
              />
            </div>

            <div class="mb-2">
              <div class="d-flex justify-space-between body-2 mb-1">
                <span>Con retroalimentación ({{ resumenVendedoraActual.conRetro }})</span>
                <span class="font-weight-medium">{{ resumenVendedoraActual.pctConRetro }}%</span>
              </div>
              <v-progress-linear
                :value="resumenVendedoraActual.pctConRetro"
                height="12"
                rounded
                color="amber darken-2"
                background-color="grey lighten-3"
              />
            </div>

            <div class="caption grey--text mt-3">
              Visto bueno: calificación ≥ {{ iaVistoBuenoMinimo }}. Promedio:
              0–50 naranja · 51–70 azul · 71–100 verde.
            </div>
          </template>

          <v-alert v-else dense outlined type="info" class="mt-2 mb-0">
            Aún no hay llamadas con intención analizadas por IA para esta vendedora.
            Abre «Llamadas con intención» y usa «Analizar con IA».
          </v-alert>
        </v-card-text>

        <v-divider />
        <v-card-actions class="pa-3">
          <v-btn
            small
            text
            color="deep-purple"
            @click="abrirModalReporte(reporteVendedoraItem, 'intencion'); cerrarModalReporteVendedora()"
          >
            Ver llamadas con intención
          </v-btn>
          <v-spacer />
          <v-btn text small @click="cerrarModalReporteVendedora">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Detalle reporte: Total / Reales / Intención -->
    <v-dialog v-model="dialogReporteDetalle" max-width="920" scrollable>
      <v-card v-if="reporteDetalleItem">
        <v-card-title class="subtitle-1">
          {{ tituloModalReporte }}
          <v-spacer />
          <v-btn icon @click="cerrarModalReporte"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-subtitle class="pb-0">
          {{ reporteDetalleItem.vendedora }}
        </v-card-subtitle>
        <v-card-text style="max-height: 70vh">
          <!-- Total de llamadas -->
          <template v-if="reporteDetalleTipo === 'total'">
            <v-simple-table dense>
              <thead>
                <tr>
                  <th>Origen</th>
                  <th>Destino</th>
                  <th>Inicio</th>
                  <th>Duración</th>
                  <th>Disposition</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(c, idx) in reporteDetalleItem.llamadas"
                  :key="'modal-tot-' + idx"
                >
                  <td>{{ c.src || '—' }}</td>
                  <td>{{ c.dst || '—' }}</td>
                  <td>{{ c.start || '—' }}</td>
                  <td>{{ formatoDuracionSeg(duracionCdr(c)) }}</td>
                  <td>{{ c.disposition || '—' }}</td>
                </tr>
                <tr v-if="!(reporteDetalleItem.llamadas || []).length">
                  <td colspan="5" class="grey--text text-center">Sin llamadas</td>
                </tr>
              </tbody>
            </v-simple-table>
          </template>

          <!-- Números marcados -->
          <template v-else-if="reporteDetalleTipo === 'reales'">
            <div class="caption grey--text mb-2">
              Clic en un número para ver sus llamadas, tiempo y audio
            </div>
            <div class="d-flex flex-wrap mb-4" style="gap: 8px">
              <v-chip
                v-for="(num, i) in reporteDetalleItem.numerosMarcados"
                :key="'modal-num-' + i"
                :outlined="reporteNumeroSeleccionado !== num"
                :color="reporteNumeroSeleccionado === num ? 'teal' : 'teal'"
                :dark="reporteNumeroSeleccionado === num"
                class="font-weight-medium"
                style="cursor: pointer"
                @click="seleccionarNumeroReal(num)"
              >
                <v-icon left x-small>mdi-phone</v-icon>
                {{ num }}
              </v-chip>
              <span
                v-if="!(reporteDetalleItem.numerosMarcados || []).length"
                class="grey--text"
              >Sin números marcados</span>
            </div>

            <template v-if="reporteNumeroSeleccionado">
              <v-divider class="mb-3" />
              <div class="subtitle-2 mb-2">
                Llamadas a {{ reporteNumeroSeleccionado }}
                ({{ llamadasNumeroRealSeleccionado.length }})
              </div>
              <div
                v-if="!llamadasNumeroRealSeleccionado.length"
                class="grey--text text-center py-3"
              >
                Sin llamadas a este número
              </div>
              <v-card
                v-for="(c, idx) in llamadasNumeroRealSeleccionado"
                :key="'modal-real-call-' + idx"
                outlined
                class="mb-3 pa-3"
              >
                <v-row dense align="center">
                  <v-col cols="12" sm="6" md="4">
                    <div class="caption grey--text">Llamada</div>
                    <div class="body-2 font-weight-medium">
                      {{ c.src || '—' }} → {{ c.dst || '—' }}
                    </div>
                    <div class="caption">{{ c.start || '—' }}</div>
                    <div class="caption">{{ c.disposition || '—' }}</div>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <div class="caption grey--text">Tiempo</div>
                    <div class="body-2 font-weight-medium">
                      {{ formatoDuracionSeg(duracionCdr(c)) }}
                    </div>
                  </v-col>
                  <v-col cols="12" md="5">
                    <div class="caption grey--text mb-1">Audio</div>
                    <CdrRecordingPlayer
                      :recordfiles="c.recordfiles"
                      :uniqueid="c.uniqueid"
                      :sucursal="c.sucursal || c.sucursal_nombre || c.nombre_sucursal || c.branch || null"
                    />
                  </v-col>
                </v-row>
              </v-card>
            </template>
          </template>

          <!-- Intención -->
          <template v-else-if="reporteDetalleTipo === 'intencion'">
            <div class="d-flex flex-wrap align-center mb-3">
              <div class="caption grey--text mr-3">
                Criterio provisional: duración &gt; 5 min · Whisper + coaching OpenAI
              </div>
              <v-spacer />
              <v-btn
                v-if="intencionesPendientesIa.length"
                small
                dark
                color="deep-purple"
                tile
                :loading="cargandoIaIntencion"
                :disabled="cargandoIaIntencion"
                @click="analizarIntencionesConIa"
              >
                <v-icon left small>mdi-robot</v-icon>
                Analizar con IA ({{ intencionesPendientesIa.length }})
              </v-btn>
            </div>
            <v-alert
              v-if="iaIntencionError"
              dense
              outlined
              type="error"
              class="mb-3"
            >
              {{ iaIntencionError }}
            </v-alert>
            <div
              v-if="!(reporteDetalleItem.intenciones || []).length"
              class="grey--text text-center py-4"
            >
              Sin llamadas con intención en este periodo
            </div>
            <v-card
              v-for="(c, idx) in reporteDetalleItem.intenciones"
              :key="'modal-int-' + idx"
              outlined
              class="mb-3 pa-3"
            >
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="3">
                  <div class="caption grey--text">Llamada</div>
                  <div class="body-2 font-weight-medium">
                    {{ c.src || '—' }} → {{ c.dst || '—' }}
                  </div>
                  <div class="caption">{{ c.start || '—' }}</div>
                  <v-chip
                    v-if="c.ia_estado"
                    x-small
                    class="mt-1 mr-1"
                    :color="chipColorIa(c.ia_estado)"
                    dark
                    label
                  >
                    {{ etiquetaEstadoIa(c.ia_estado) }}
                  </v-chip>
                  <v-chip
                    v-if="c.ia_calificacion != null"
                    x-small
                    class="mt-1"
                    :color="colorBarraIa(c.ia_calificacion)"
                    dark
                    label
                  >
                    {{ c.ia_calificacion }}/100
                  </v-chip>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <div class="caption grey--text">Tiempo audio</div>
                  <div class="body-2 font-weight-medium">
                    {{ formatoDuracionSeg(duracionCdr(c)) }}
                  </div>
                </v-col>
                <v-col cols="12" sm="12" md="3">
                  <div class="caption grey--text mb-1">Audio</div>
                  <CdrRecordingPlayer
                    :recordfiles="c.recordfiles"
                    :uniqueid="c.uniqueid"
                    :sucursal="sucursalDeCdr(c)"
                  />
                </v-col>
                <v-col cols="12" md="4" class="d-flex flex-wrap align-center justify-end" style="gap: 8px;">
                  <v-btn
                    small
                    tile
                    outlined
                    color="deep-purple"
                    @click="abrirModalIaDetalle(c)"
                  >
                    <v-icon left small>mdi-text-box-outline</v-icon>
                    Ver IA
                  </v-btn>
                  <v-btn
                    v-if="necesitaAnalizarIa(c)"
                    small
                    tile
                    dark
                    color="deep-purple"
                    :loading="c._iaLoading"
                    @click="analizarUnaLlamadaIa(c)"
                  >
                    <v-icon left small>mdi-robot</v-icon>
                    Analizar
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </template>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cerrarModalReporte">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Detalle IA por llamada (reporte + transcripción) -->
    <v-dialog v-model="dialogIaDetalle" max-width="640" scrollable>
      <v-card v-if="iaDetalleLlamada" class="ia-reporte-dialog">
        <div class="ia-reporte-header px-4 py-3 white--text">
          <div class="d-flex align-center">
            <div class="flex-grow-1">
              <div class="text-h6 font-weight-bold">Reporte de llamada</div>
              <div class="caption" style="opacity: 0.9;">
                Prospecto: {{ etiquetaProspectoIa(iaDetalleLlamada) }}
                · Sucursal {{ sucursalDeCdr(iaDetalleLlamada) || '—' }}
              </div>
            </div>
            <v-chip
              v-if="iaDetalleLlamada.ia_estado"
              small
              dark
              label
              :color="chipColorIa(iaDetalleLlamada.ia_estado)"
              class="mr-2"
            >
              {{ etiquetaEstadoIa(iaDetalleLlamada.ia_estado) }}
            </v-chip>
            <v-btn icon dark @click="cerrarModalIaDetalle"><v-icon>mdi-close</v-icon></v-btn>
          </div>
        </div>

        <v-card-text class="pt-4 px-4" style="max-height: 72vh">
          <div class="caption grey--text mb-1">
            {{ iaDetalleLlamada.start || '—' }}
            · {{ formatoDuracionSeg(duracionCdr(iaDetalleLlamada)) }}
            · {{ iaDetalleLlamada.disposition || '—' }}
          </div>

          <div class="mb-4">
            <CdrRecordingPlayer
              :recordfiles="iaDetalleLlamada.recordfiles"
              :uniqueid="iaDetalleLlamada.uniqueid"
              :sucursal="sucursalDeCdr(iaDetalleLlamada)"
            />
          </div>

          <v-alert
            v-if="iaDetalleLlamada.ia_error"
            dense
            outlined
            type="error"
            class="mb-4"
          >
            {{ iaDetalleLlamada.ia_error }}
          </v-alert>

          <div v-if="iaDetalleLlamada.ia_estado === 'processing'" class="text-center py-6 grey--text">
            <v-progress-circular indeterminate color="deep-purple" class="mb-2" />
            <div>Analizando llamada…</div>
          </div>

          <template v-else-if="tienePuntajesIa(iaDetalleLlamada)">
            <div
              class="ia-visto-bueno mb-4 pa-3 d-flex align-center"
              :class="vistoBuenoIa(iaDetalleLlamada) ? 'ia-visto-bueno--ok' : 'ia-visto-bueno--warn'"
            >
              <v-icon
                left
                :color="vistoBuenoIa(iaDetalleLlamada) ? 'success' : 'orange darken-2'"
              >
                {{ vistoBuenoIa(iaDetalleLlamada) ? 'mdi-check-circle' : 'mdi-alert-circle-outline' }}
              </v-icon>
              <div>
                <div class="font-weight-bold body-2">
                  {{ vistoBuenoIa(iaDetalleLlamada) ? 'Visto bueno de la IA' : 'Requiere mejora' }}
                </div>
                <div class="caption">
                  {{ mensajeVistoBuenoIa(iaDetalleLlamada) }}
                  <span v-if="iaDetalleLlamada.ia_calificacion != null">
                    · Calificación {{ iaDetalleLlamada.ia_calificacion }}/100
                  </span>
                </div>
              </div>
            </div>

            <div
              v-for="metrica in metricasIaLista(iaDetalleLlamada)"
              :key="metrica.key"
              class="mb-3"
            >
              <div class="d-flex justify-space-between align-center mb-1">
                <span class="body-2 font-weight-medium">{{ metrica.label }}</span>
                <span class="body-2 font-weight-bold">{{ metrica.valor }}</span>
              </div>
              <v-progress-linear
                :value="metrica.valor"
                height="10"
                rounded
                :color="colorBarraIa(metrica.valor)"
                background-color="grey lighten-3"
              />
            </div>

            <v-divider class="my-4" />

            <div class="subtitle-2 font-weight-bold mb-2">Retroalimentación de la IA</div>
            <div class="body-2 ia-retro-text" style="white-space: pre-wrap;">
              {{ formatearRetroIa(iaDetalleLlamada.sugerencia || iaDetalleLlamada.ia_sugerencia) }}
            </div>
          </template>

          <v-card v-else outlined class="mb-4 pa-4 text-center grey--text">
            <v-icon large color="grey lighten-1" class="mb-2">mdi-robot-outline</v-icon>
            <div>Sin análisis aún. Pulsa «Analizar» para generar el reporte.</div>
          </v-card>

          <v-expansion-panels v-if="iaDetalleLlamada.transcripcion || iaDetalleLlamada.ia_transcripcion" flat class="mt-4">
            <v-expansion-panel>
              <v-expansion-panel-header class="px-0 subtitle-2">
                <v-icon left small color="deep-purple">mdi-microphone-message</v-icon>
                Transcripción (Whisper)
              </v-expansion-panel-header>
              <v-expansion-panel-content class="body-2" style="white-space: pre-wrap;">
                {{ iaDetalleLlamada.transcripcion || iaDetalleLlamada.ia_transcripcion }}
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>

        <v-divider />
        <v-card-actions class="pa-3">
          <v-btn
            v-if="necesitaAnalizarIa(iaDetalleLlamada)"
            small
            dark
            color="deep-purple"
            tile
            :loading="iaDetalleLlamada._iaLoading"
            @click="analizarUnaLlamadaIa(iaDetalleLlamada)"
          >
            <v-icon left small>mdi-robot</v-icon>
            Analizar
          </v-btn>
          <v-btn
            v-if="puedeReanalizarIa(iaDetalleLlamada)"
            small
            outlined
            color="deep-purple"
            tile
            :loading="iaDetalleLlamada._iaLoading"
            @click="analizarUnaLlamadaIa(iaDetalleLlamada)"
          >
            <v-icon left small>mdi-refresh</v-icon>
            Re-analizar
          </v-btn>
          <v-spacer />
          <v-btn text small @click="cerrarModalIaDetalle">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
  </v-container>
</template>

<script>
import Alerta from '@/components/alertas/Alerta.vue'
import CdrRecordingPlayer from '@/components/telefonia/CdrRecordingPlayer.vue'
import DialogSucursalOrigen from '@/components/telefonia/DialogSucursalOrigen.vue'
import validarErrores from '@/mixins/validarErrores'
import telefoniaApi from '@/api/telefonia'

export default {
  name: 'TelefoniaDashboard',

  components: { Alerta, CdrRecordingPlayer, DialogSucursalOrigen },

  mixins: [validarErrores],

  data () {
    const hoy = new Date()
    const hace7 = new Date(hoy.getTime() - 7 * 24 * 60 * 60 * 1000)
    const fmt = (d) => d.toISOString().slice(0, 10)
    return {
      tab: 0,
      parametros: { dialogError: false, mensaje: '', color: '' },
      respuestaAlerta: false,
      dialogSucursalOrigen: false,
      vistaReporteLlamadas: false,
      cargarAsignacionesReporte: false,
      asignacionesReporte: [],
      dialogReporteDetalle: false,
      reporteDetalleTipo: null,
      reporteDetalleItem: null,
      reporteNumeroSeleccionado: null,
      cargandoIaIntencion: false,
      iaIntencionError: '',
      cdrMetaHint: '',
      dialogIaDetalle: false,
      iaDetalleLlamada: null,
      iaVistoBuenoMinimo: 76,
      dialogReporteVendedora: false,
      reporteVendedoraItem: null,

      filtros: {
        startDate: fmt(hace7),
        endDate: fmt(hoy),
        numRecords: 50,
        page: 1
      },
      /** Filtros solo en vista (sobre el resultado CDR ya cargado). */
      filtrosVistaCdr: {
        disposition: null,
        sentido: null
      },
      filtrosStats: {
        startDate: fmt(hace7),
        endDate: fmt(hoy),
        numRecords: 500,
        page: 1
      },

      /** Inbi = 1, Fast = 2 (unidad de negocio / escuela). */
      escuelaSeleccionada: 1,
      opcionesEscuela: [
        { text: 'INBI', value: 1 },
        { text: 'FAST', value: 2 }
      ],
      plantelesLista: [],
      cargarPlanteles: false,
      idPlantelSeleccionado: null,

      cargarCdr: false,
      cdrRecords: [],
      cdrRaw: null,
      cdrError: '',

      cargarStats: false,
      stats: null,
      sampleSize: null,
      topExtensiones: [],
      statsError: '',

      cargarExt: false,
      extensionsData: null,
      extError: '',

      cargarStatus: false,
      statusData: null,
      statusError: '',

      headersCdr: [
        { text: 'Sucursal', value: 'plantel', width: '90' },
        { text: 'Origen', value: 'src', width: '90' },
        { text: 'Destino', value: 'dst', width: '90' },
        { text: 'Inicio', value: 'start', width: '140' },
        { text: 'Answer', value: 'answer', width: '140' },
        { text: 'Fin', value: 'end', width: '140' },
        { text: 'Duración', value: 'billsec', width: '80' },
        { text: 'Disposition', value: 'disposition', width: '110' },
        { text: 'Sentido', value: 'userfield', width: '100' },
        { text: 'Grabación', value: 'recordfiles', width: '260', sortable: false }
      ],
      headersReporteLlamadas: [
        { text: 'Posición', value: 'posicion', width: '90' },
        { text: 'Vendedora', value: 'vendedora' },
        { text: 'Total de llamadas', value: 'totalLlamadas', width: '150' },
        { text: 'Llamadas reales', value: 'llamadasReales', width: '150' },
        { text: 'Llamadas con intención', value: 'llamadasIntencion', width: '170' }
      ]
    }
  },

  watch: {
    escuelaSeleccionada () {
      this.$nextTick(() => this.syncPlantelTrasCambioEscuela())
    },
    plantelesFiltradosPorEscuela () {
      this.syncPlantelTrasCambioEscuela()
    }
  },

  created () {
    this.inicializarTelefonia()
  },

  computed: {
    /** Valores únicos de disposition en el último resultado (para el filtro). */
    opcionesDispositionCdr () {
      const set = new Set()
      for (const r of this.cdrRecords || []) {
        if (r.disposition != null && String(r.disposition).trim() !== '') {
          set.add(String(r.disposition).trim())
        }
      }
      return Array.from(set).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
    },
    /** Planteles activos de la escuela elegida (INBI / FAST). */
    plantelesFiltradosPorEscuela () {
      const e = Number(this.escuelaSeleccionada)
      const list = this.plantelesLista || []
      return list.filter((p) => this.plantelPerteneceAEscuela(p, e))
    },
    /**
     * Identificadores que el CDR puede traer en `sucursal` (texto): suele ser `id_plantel`,
     * a veces nombre o wpp_sucursal. Unión de todos los planteles de la escuela elegida.
     */
    identificadoresSucursalEscuelaActual () {
      const set = new Set()
      for (const p of this.plantelesFiltradosPorEscuela || []) {
        for (const id of this.identificadoresPlantel(p)) {
          if (id) set.add(id)
        }
      }
      return Array.from(set)
    },
    /** Filas CDR según filtros de vista (disposition / sentido / sucursal). */
    cdrRecordsFiltrados () {
      let rows = this.cdrRecords || []
      const disp = this.filtrosVistaCdr.disposition
      if (disp != null && String(disp).trim() !== '') {
        const d = String(disp).trim().toUpperCase()
        rows = rows.filter((r) => String(r.disposition || '').trim().toUpperCase() === d)
      }
      const sent = this.filtrosVistaCdr.sentido
      if (sent != null && String(sent).trim() !== '') {
        const s = String(sent).toLowerCase()
        rows = rows.filter((r) => {
          const uf = String(r.userfield || '').toLowerCase()
          if (s === 'inbound') return uf.indexOf('inbound') !== -1
          if (s === 'outbound') return uf.indexOf('outbound') !== -1
          return true
        })
      }
      rows = rows.filter((r) => this.filaCdrCoincideFiltroSucursal(r))
      return rows
    },
    /**
     * Mismas métricas que la pestaña Estadísticas, calculadas sobre el resultado CDR
     * ya cargado y con los filtros de vista (disposition / sentido) aplicados.
     */
    statsCdrVista () {
      const rows = this.cdrRecordsFiltrados || []
      const n = rows.length
      let entrantes = 0
      let salientes = 0
      let contestadas = 0
      let noContestadas = 0
      let sumBill = 0
      let cntBill = 0
      for (const r of rows) {
        const uf = String(r.userfield || '').toLowerCase()
        if (uf.indexOf('inbound') !== -1) entrantes++
        if (uf.indexOf('outbound') !== -1) salientes++
        const disp = String(r.disposition || '').trim().toUpperCase()
        if (disp === 'ANSWERED') contestadas++
        if (disp === 'NO ANSWER' || disp.indexOf('NO ANSWER') !== -1) noContestadas++
        const b = parseFloat(r.billsec)
        if (!Number.isNaN(b)) {
          sumBill += b
          cntBill++
        }
      }
      const duracionPromedio = cntBill > 0 ? sumBill / cntBill : null
      return {
        total: n,
        entrantes,
        salientes,
        contestadas,
        noContestadas,
        duracionPromedio,
        muestra: n
      }
    },
    /**
     * Ranking a partir del CDR filtrado + asignaciones (responsable de la línea).
     * - total: lista de todas las llamadas
     * - reales: números destino (dst) únicos marcados
     * - intención (provisional): duración (billsec/duration) > 300 s
     */
    reporteLlamadasRows () {
      const asignaciones = this.asignacionesReporte || []
      const rowsCdr = this.cdrRecordsFiltrados || []
      if (!asignaciones.length || !rowsCdr.length) return []

      const byKey = new Map()
      const byOrigen = new Map()
      for (const a of asignaciones) {
        const resp = String(a.responsable || '').trim()
        if (!resp) continue
        const origen = String(a.origen || '').trim()
        const suc = String(a.sucursal || '').trim()
        if (!origen) continue
        const k = this.claveAsignacion(suc, origen)
        byKey.set(k, resp)
        const oKey = this.normTxt(origen)
        if (!byOrigen.has(oKey)) byOrigen.set(oKey, resp)
        else if (byOrigen.get(oKey) !== resp) {
          byOrigen.set(oKey, null)
        }
      }

      /** @type {Map<string, { vendedora: string, llamadas: Array, destinos: Set<string>, intenciones: Array }>} */
      const ag = new Map()

      for (const r of rowsCdr) {
        const origen = String(r.src != null ? r.src : '').trim()
        if (!origen) continue
        const plantel = this.plantelDeFilaCdr(r)
        let vendedora =
          byKey.get(this.claveAsignacion(plantel, origen)) ||
          null
        if (!vendedora) {
          const solo = byOrigen.get(this.normTxt(origen))
          if (solo) vendedora = solo
        }
        if (!vendedora) continue

        const keyVend = this.normTxt(vendedora)
        let bucket = ag.get(keyVend)
        if (!bucket) {
          bucket = {
            vendedora,
            llamadas: [],
            destinos: new Set(),
            intenciones: []
          }
          ag.set(keyVend, bucket)
        }
        bucket.llamadas.push(r)
        const dst = r.dst != null ? String(r.dst).trim() : ''
        if (dst) bucket.destinos.add(dst)
        // Provisional: intención = llamada larga (> 5 min). Luego se reemplaza por lógica real.
        if (this.duracionCdr(r) > 300) {
          bucket.intenciones.push({
            ...r,
            transcripcion: r.ia_transcripcion || null,
            sugerencia: r.ia_sugerencia || null,
            ia_estado: r.ia_estado || null,
            ia_error: r.ia_error || null,
            ia_calificacion: r.ia_calificacion != null ? r.ia_calificacion : null,
            ia_visto_bueno: !!r.ia_visto_bueno,
            ia_puntajes: r.ia_puntajes || null,
            _iaLoading: false
          })
        }
      }

      const lista = Array.from(ag.values()).map((b) => {
        const numerosMarcados = Array.from(b.destinos).sort((a, c) =>
          String(a).localeCompare(String(c), 'es')
        )
        return {
          vendedora: b.vendedora,
          totalLlamadas: b.llamadas.length,
          llamadasReales: numerosMarcados.length,
          llamadasIntencion: b.intenciones.length,
          llamadas: b.llamadas,
          numerosMarcados,
          intenciones: b.intenciones
        }
      })

      lista.sort((a, b) => {
        if (b.llamadasIntencion !== a.llamadasIntencion) {
          return b.llamadasIntencion - a.llamadasIntencion
        }
        if (b.llamadasReales !== a.llamadasReales) {
          return b.llamadasReales - a.llamadasReales
        }
        if (b.totalLlamadas !== a.totalLlamadas) {
          return b.totalLlamadas - a.totalLlamadas
        }
        return String(a.vendedora).localeCompare(String(b.vendedora), 'es')
      })

      return lista.map((row, idx) => ({
        posicion: idx + 1,
        ...row
      }))
    },
    cdrRawStr () {
      if (this.cdrRaw == null) return ''
      return typeof this.cdrRaw === 'string' ? this.cdrRaw : JSON.stringify(this.cdrRaw, null, 2)
    },
    extensionsJson () {
      if (this.extensionsData == null) return ''
      return typeof this.extensionsData === 'string'
        ? this.extensionsData
        : JSON.stringify(this.extensionsData, null, 2)
    },
    statusJson () {
      if (this.statusData == null) return ''
      return typeof this.statusData === 'string'
        ? this.statusData
        : JSON.stringify(this.statusData, null, 2)
    },
    tituloModalReporte () {
      const mapa = {
        total: 'Total de llamadas',
        reales: 'Llamadas reales — números marcados',
        intencion: 'Llamadas con intención'
      }
      return mapa[this.reporteDetalleTipo] || 'Detalle'
    },
    /** Llamadas del modal intención sin análisis IA listo. */
    intencionesPendientesIa () {
      const item = this.reporteDetalleItem
      const list = (item && item.intenciones) || []
      return list.filter((c) => this.necesitaAnalizarIa(c))
    },
    periodoReporteLabel () {
      const a = this.filtros.startDate
      const b = this.filtros.endDate
      if (a && b) return `${a} — ${b}`
      return 'Periodo seleccionado'
    },
    resumenVendedoraActual () {
      const item = this.reporteVendedoraItem
      const vacio = {
        totalAnalizadas: 0,
        promedio: 0,
        vistoBueno: 0,
        conRetro: 0,
        pctVistoBueno: 0,
        pctConRetro: 0,
        puntosMejora: []
      }
      if (!item) return vacio
      const analizadas = (item.intenciones || []).filter((c) => this.estaAnalizadaIa(c))
      if (!analizadas.length) return vacio

      const calificaciones = analizadas
        .map((c) => this.puntajeIaNumero(c.ia_calificacion))
        .filter((n) => n > 0)
      const promedio = calificaciones.length
        ? Math.round(calificaciones.reduce((a, b) => a + b, 0) / calificaciones.length)
        : 0
      const vistoBueno = analizadas.filter((c) => this.vistoBuenoIa(c)).length
      const conRetro = analizadas.length - vistoBueno
      const total = analizadas.length

      return {
        totalAnalizadas: total,
        promedio,
        vistoBueno,
        conRetro,
        pctVistoBueno: total ? Math.round((vistoBueno / total) * 100) : 0,
        pctConRetro: total ? Math.round((conRetro / total) * 100) : 0,
        puntosMejora: this.agruparPuntosMejora(analizadas)
      }
    },
    /** Llamadas del vendedor al número seleccionado en modal de reales. */
    llamadasNumeroRealSeleccionado () {
      const item = this.reporteDetalleItem
      const num = this.reporteNumeroSeleccionado
      if (!item || !num) return []
      const dest = String(num).trim()
      return (item.llamadas || []).filter(
        (c) => String(c.dst != null ? c.dst : '').trim() === dest
      )
    }
  },

  methods: {
    normSuc (s) {
      return String(s || '').trim().toLowerCase()
    },
    /** Valores posibles de `record.sucursal` para un plantel (CDR manda id_plantel como texto). */
    identificadoresPlantel (p) {
      if (!p) return []
      const out = []
      if (p.id_plantel != null && String(p.id_plantel).trim() !== '') {
        out.push(this.normSuc(String(p.id_plantel)))
      }
      const w = p.wpp_sucursal != null ? String(p.wpp_sucursal).trim() : ''
      if (w !== '') out.push(this.normSuc(w))
      const pl = String(p.plantel || '').trim()
      if (pl !== '') out.push(this.normSuc(pl))
      return out
    },
    /** Carpeta / query API: prioriza id numérico como en CDR; si no, wpp_sucursal o nombre. */
    sucursalDelPlantel (p) {
      if (!p) return ''
      if (p.id_plantel != null && String(p.id_plantel).trim() !== '') {
        return String(p.id_plantel).trim()
      }
      const w = p.wpp_sucursal != null ? String(p.wpp_sucursal).trim() : ''
      if (w !== '') return w
      return String(p.plantel || '').trim()
    },
    sucursalDeFila (r) {
      if (!r) return ''
      return r.sucursal || r.sucursal_nombre || r.nombre_sucursal || r.branch || ''
    },
    plantelPerteneceAEscuela (p, e) {
      if (p == null || Number.isNaN(e)) return false
      if (p.escuela != null && String(p.escuela).trim() !== '') {
        return Number(p.escuela) === e
      }
      if (p.idunidad_negocio != null && String(p.idunidad_negocio).trim() !== '') {
        return Number(p.idunidad_negocio) === e
      }
      const nombre = String(p.plantel || '').toUpperCase()
      if (e === 2) return nombre.indexOf('FAST') !== -1
      if (e === 1) return nombre.indexOf('FAST') === -1
      return false
    },
    filaCdrCoincideFiltroSucursal (r) {
      const key = this.normSuc(this.sucursalDeFila(r))
      if (this.idPlantelSeleccionado != null && this.idPlantelSeleccionado !== '') {
        const p = this.plantelesLista.find(
          (x) => String(x.id_plantel) === String(this.idPlantelSeleccionado)
        )
        if (!p) return true
        const idsPlantel = this.identificadoresPlantel(p)
        if (!idsPlantel.length) return true
        if (!key) return false
        return idsPlantel.indexOf(key) !== -1
      }
      const permitidas = this.identificadoresSucursalEscuelaActual
      if (!permitidas.length) return true
      if (!key) return false
      return permitidas.indexOf(key) !== -1
    },
    syncPlantelTrasCambioEscuela () {
      if (this.idPlantelSeleccionado == null || this.idPlantelSeleccionado === '') return
      const ok = this.plantelesFiltradosPorEscuela.some(
        (p) => String(p.id_plantel) === String(this.idPlantelSeleccionado)
      )
      if (!ok) this.idPlantelSeleccionado = null
    },
    async inicializarTelefonia () {
      await this.cargarPlantelesLista()
      await this.alinearFechasConCdrDisponible()
      await this.cargarCdrLista()
    },

    /**
     * En staging/pruebas el agente a veces no sincroniza hasta “hoy”.
     * Si el rango por defecto (últimos 7 días) queda vacío, usa la última semana con datos.
     */
    async alinearFechasConCdrDisponible () {
      try {
        const { data } = await telefoniaApi.getCdrMeta()
        if (!data || !data.success || !data.maxDate) return

        const maxDate = String(data.maxDate).slice(0, 10)
        const minDate = data.minDate ? String(data.minDate).slice(0, 10) : null
        this.cdrMetaHint =
          `Datos en BD: ${data.total || 0} registros` +
          (minDate && maxDate ? ` (${minDate} → ${maxDate})` : '')

        const hoy = this.filtros.endDate
        // Si “hoy” está después del último CDR, mover el rango a la última semana disponible
        if (hoy && maxDate && hoy > maxDate) {
          const end = new Date(maxDate + 'T12:00:00')
          const start = new Date(end)
          start.setDate(start.getDate() - 7)
          let startStr = start.toISOString().slice(0, 10)
          if (minDate && startStr < minDate) startStr = minDate
          const endStr = maxDate
          this.filtros.startDate = startStr
          this.filtros.endDate = endStr
          this.filtrosStats.startDate = startStr
          this.filtrosStats.endDate = endStr
          console.log('[TelefoniaDashboard] fechas alineadas a CDR disponible', {
            startStr,
            endStr,
            total: data.total
          })
        }
      } catch (e) {
        console.warn('[TelefoniaDashboard] cdr-meta:', this.mensajeHttp(e))
      }
    },

    async cargarPlantelesLista () {
      this.cargarPlanteles = true
      try {
        const { data } = await this.$http.get('planteles.activos')
        this.plantelesLista = Array.isArray(data) ? data : []
      } catch (e) {
        this.plantelesLista = []
        const msg = (e.response && e.response.data && e.response.data.message) || e.message || 'Error al cargar planteles'
        this.validarError(msg)
      } finally {
        this.cargarPlanteles = false
      }
      console.log('[TelefoniaDashboard] planteles.activos listos', {
        total: this.plantelesLista.length,
        muestra: this.plantelesLista.slice(0, 8).map((p) => ({
          id_plantel: p.id_plantel,
          plantel: p.plantel,
          escuela: p.escuela,
          idunidad_negocio: p.idunidad_negocio,
          wpp_sucursal: p.wpp_sucursal
        }))
      })
    },

    mensajeHttp (error) {
      if (error.response && error.response.data) {
        const d = error.response.data
        if (typeof d === 'string') return d
        if (d.message) return d.message
        if (d.error) return typeof d.error === 'string' ? d.error : JSON.stringify(d.error)
      }
      return error.message || 'Error de conexión'
    },

    onSucursalOrigenSuccess (mensaje) {
      if (mensaje) this.validarSuccess(mensaje)
      if (this.vistaReporteLlamadas) this.cargarAsignacionesParaReporte()
    },

    normTxt (s) {
      return String(s || '').trim().toLowerCase()
    },
    claveAsignacion (sucursal, origen) {
      return this.normTxt(sucursal) + '|' + this.normTxt(origen)
    },
    plantelDeFilaCdr (r) {
      if (!r) return ''
      if (r.plantel != null && String(r.plantel).trim() !== '') {
        return String(r.plantel).trim()
      }
      return String(
        r.sucursal || r.sucursal_nombre || r.nombre_sucursal || r.branch || ''
      ).trim()
    },
    /** Duración en segundos: billsec preferido, si no duration. */
    duracionCdr (r) {
      if (!r) return 0
      const b = parseFloat(r.billsec)
      if (!Number.isNaN(b)) return b
      const d = parseFloat(r.duration)
      if (!Number.isNaN(d)) return d
      return 0
    },
    /** Formato mm:ss o hh:mm:ss para el reporte. */
    formatoDuracionSeg (segundos) {
      const s = Math.max(0, Math.floor(Number(segundos) || 0))
      const h = Math.floor(s / 3600)
      const m = Math.floor((s % 3600) / 60)
      const sec = s % 60
      if (h > 0) {
        return `${h}:${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`
      }
      return `${m}:${String(sec).padStart(2, '0')}`
    },
    async toggleReporteLlamadas () {
      if (this.vistaReporteLlamadas) {
        this.vistaReporteLlamadas = false
        this.cerrarModalReporte()
        return
      }
      if (!this.cdrRecords.length) {
        this.validarError('Consulta CDR primero para generar el reporte')
        return
      }
      await this.cargarAsignacionesParaReporte()
      this.vistaReporteLlamadas = true
      this.cerrarModalReporte()
    },
    abrirModalReporte (item, tipo) {
      this.reporteDetalleItem = item || null
      this.reporteDetalleTipo = tipo || null
      this.reporteNumeroSeleccionado = null
      this.iaIntencionError = ''
      this.dialogReporteDetalle = true
    },
    abrirModalReporteVendedora (item) {
      if (!item) return
      this.reporteVendedoraItem = item
      this.dialogReporteVendedora = true
    },
    cerrarModalReporteVendedora () {
      this.dialogReporteVendedora = false
      this.reporteVendedoraItem = null
    },
    cerrarModalReporte () {
      this.dialogReporteDetalle = false
      this.reporteDetalleTipo = null
      this.reporteDetalleItem = null
      this.reporteNumeroSeleccionado = null
      this.iaIntencionError = ''
      this.cargandoIaIntencion = false
    },
    sucursalDeCdr (c) {
      if (!c) return null
      return (
        c.sucursal ||
        c.sucursal_nombre ||
        c.nombre_sucursal ||
        c.branch ||
        null
      )
    },
    tieneResultadoIa (c) {
      if (!c) return false
      return !!(
        c.transcripcion ||
        c.sugerencia ||
        c.ia_transcripcion ||
        c.ia_sugerencia ||
        this.tienePuntajesIa(c)
      )
    },

    parseIaPuntajes (c) {
      if (!c || c.ia_puntajes == null) return null
      if (typeof c.ia_puntajes === 'object') return c.ia_puntajes
      try {
        return JSON.parse(String(c.ia_puntajes))
      } catch (e) {
        return null
      }
    },

    tienePuntajesIa (c) {
      const p = this.parseIaPuntajes(c)
      return !!(p && (p.tono_actitud != null || p.guion_seguido != null))
    },

    etiquetaProspectoIa (c) {
      if (!c) return '—'
      const nombre = c.caller_name && String(c.caller_name).trim()
      if (nombre) return nombre
      const dst = c.dst != null ? String(c.dst).trim() : ''
      return dst || 'Sin identificar'
    },

    mensajeVistoBuenoIa (c) {
      const p = this.parseIaPuntajes(c)
      if (p && p.visto_bueno_mensaje) return p.visto_bueno_mensaje
      if (this.vistoBuenoIa(c)) return 'Cumple el guion de llamada'
      return 'Requiere mejorar la llamada'
    },

    vistoBuenoIa (c) {
      if (!c) return false
      if (c.ia_calificacion != null) {
        return this.puntajeIaNumero(c.ia_calificacion) >= this.iaVistoBuenoMinimo
      }
      return !!c.ia_visto_bueno
    },

    metricasIaLista (c) {
      const p = this.parseIaPuntajes(c) || {}
      const defs = [
        { key: 'tono_actitud', label: 'Tono y actitud' },
        { key: 'guion_seguido', label: 'Guion seguido' },
        { key: 'manejo_objeciones', label: 'Manejo de objeciones' },
        { key: 'cierre_siguiente_paso', label: 'Cierre / siguiente paso' }
      ]
      return defs.map((d) => ({
        key: d.key,
        label: d.label,
        valor: this.puntajeIaNumero(p[d.key])
      }))
    },

    puntajeIaNumero (v) {
      const n = Number(v)
      if (!Number.isFinite(n)) return 0
      return Math.max(0, Math.min(100, Math.round(n)))
    },

    colorBarraIa (valor) {
      const v = this.puntajeIaNumero(valor)
      if (v >= 71) return 'success'
      if (v >= 51) return 'blue darken-1'
      return 'orange darken-2'
    },

    colorPromedioIa (valor) {
      return this.colorBarraIa(valor)
    },

    colorPromedioHex (valor) {
      const v = this.puntajeIaNumero(valor)
      if (v <= 50) return '#F57C00'
      if (v <= 70) return '#1E88E5'
      return '#43A047'
    },

    extraerBulletsMejora (texto) {
      const t = this.formatearRetroIa(texto)
      if (!t) return []
      const match = t.match(/3\)\s*[ÁA]reas de mejora\s*([\s\S]*)$/i)
      const block = match ? match[1] : ''
      if (!block) return []
      const bullets = []
      for (const line of block.split('\n')) {
        const trimmed = String(line || '').trim()
        if (!trimmed) continue
        const dash = trimmed.match(/^[-•*]\s*(.+)/)
        const numbered = trimmed.match(/^\d+\.\s*(.+)/)
        if (dash) bullets.push(dash[1].trim())
        else if (numbered) bullets.push(numbered[1].trim())
      }
      return bullets
    },

    agruparPuntosMejora (analizadas) {
      const counts = new Map()
      for (const c of analizadas || []) {
        const texto = c.sugerencia || c.ia_sugerencia || ''
        for (const bullet of this.extraerBulletsMejora(texto)) {
          const key = this.normTxt(bullet)
          if (!key || key.length < 8) continue
          const prev = counts.get(key) || { texto: bullet, count: 0 }
          prev.count += 1
          counts.set(key, prev)
        }
      }
      return Array.from(counts.values())
        .sort((a, b) => b.count - a.count || a.texto.localeCompare(b.texto, 'es'))
        .slice(0, 5)
    },

    formatearRetroIa (texto) {
      let t = texto != null ? String(texto).trim() : ''
      if (!t) return ''
      t = t.replace(/\\n/g, '\n')
      t = t.replace(/\s+(?=[23]\)\s)/g, '\n\n')
      t = t.replace(/(\d\)\s[^-\n]+?)\s+-\s+/g, '$1\n\n')
      t = t.replace(/\.\s+-\s+/g, '.\n- ')
      t = t.replace(/\n{3,}/g, '\n\n')
      return t.trim()
    },

    abrirModalIaDetalle (c) {
      if (!c) return
      this.iaDetalleLlamada = c
      this.dialogIaDetalle = true
    },

    cerrarModalIaDetalle () {
      this.dialogIaDetalle = false
      this.iaDetalleLlamada = null
    },

    chipColorIa (estado) {
      const e = String(estado || '').toLowerCase()
      if (e === 'done') return 'success'
      if (e === 'processing') return 'info'
      if (e === 'error') return 'error'
      return 'grey'
    },
    etiquetaEstadoIa (estado) {
      const e = String(estado || '').toLowerCase()
      if (e === 'done') return 'Analizada'
      if (e === 'processing') return 'Procesando'
      if (e === 'error') return 'Error IA'
      return e || 'Pendiente'
    },
    puedeAnalizarUna (c) {
      if (!c) return false
      const uid = c.uniqueid != null ? String(c.uniqueid).trim() : ''
      const suc = this.sucursalDeCdr(c)
      if (!uid || !suc) return false
      const est = String(c.ia_estado || '').toLowerCase()
      if (est === 'processing' || c._iaLoading) return false
      return true
    },
    estaAnalizadaIa (c) {
      if (!c) return false
      const est = String(c.ia_estado || '').toLowerCase()
      if (est !== 'done') return false
      return this.tienePuntajesIa(c) || !!(c.sugerencia || c.ia_sugerencia)
    },
    necesitaAnalizarIa (c) {
      return this.puedeAnalizarUna(c) && !this.estaAnalizadaIa(c)
    },
    puedeReanalizarIa (c) {
      return this.puedeAnalizarUna(c) && this.estaAnalizadaIa(c)
    },
    payloadLlamadaIa (c) {
      return {
        uniqueid: String(c.uniqueid).trim(),
        sucursal: String(this.sucursalDeCdr(c)).trim(),
        recording_url: c.recording_url || undefined,
        recordfiles: c.recordfiles || undefined
      }
    },
    aplicarResultadoIa (c, res) {
      if (!c || !res) return
      const ok = !!res.ok
      this.$set(c, 'transcripcion', res.ia_transcripcion || c.transcripcion || null)
      this.$set(c, 'sugerencia', res.ia_sugerencia || null)
      this.$set(c, 'ia_estado', res.ia_estado || (ok ? 'done' : 'error'))
      this.$set(c, 'ia_error', res.error || res.ia_error || null)
      this.$set(c, 'ia_transcripcion', c.transcripcion)
      this.$set(c, 'ia_sugerencia', c.sugerencia)
      this.$set(c, 'ia_calificacion', res.ia_calificacion != null ? res.ia_calificacion : null)
      this.$set(c, 'ia_visto_bueno', res.ia_calificacion != null
        ? this.puntajeIaNumero(res.ia_calificacion) >= this.iaVistoBuenoMinimo
        : (res.ia_visto_bueno === true || res.ia_visto_bueno === 1))
      this.$set(c, 'ia_puntajes', res.ia_puntajes || null)
      this.$set(c, '_iaLoading', false)

      const uid = String(c.uniqueid || '').trim()
      const suc = String(this.sucursalDeCdr(c) || '').trim()
      for (const row of this.cdrRecords || []) {
        if (String(row.uniqueid || '').trim() !== uid) continue
        if (String(this.sucursalDeCdr(row) || '').trim() !== suc) continue
        this.$set(row, 'ia_transcripcion', c.transcripcion || '')
        this.$set(row, 'ia_sugerencia', c.sugerencia || '')
        this.$set(row, 'ia_estado', c.ia_estado || '')
        this.$set(row, 'ia_error', c.ia_error || '')
        this.$set(row, 'ia_calificacion', c.ia_calificacion)
        this.$set(row, 'ia_visto_bueno', c.ia_visto_bueno)
        this.$set(row, 'ia_puntajes', c.ia_puntajes)
      }
    },
    refrescarItemModalReporte () {
      if (!this.reporteDetalleItem || !this.reporteDetalleItem.vendedora) return
      const vend = this.reporteDetalleItem.vendedora
      const fresh = (this.reporteFilasLlamadas || []).find(
        (r) => r.vendedora === vend
      )
      if (fresh) this.reporteDetalleItem = fresh
    },
    async analizarUnaLlamadaIa (c) {
      if (!this.necesitaAnalizarIa(c) && !this.puedeReanalizarIa(c)) return
      this.iaIntencionError = ''
      this.$set(c, '_iaLoading', true)
      this.$set(c, 'ia_estado', 'processing')
      try {
        const { data } = await telefoniaApi.analizarLoteIa({
          llamadas: [this.payloadLlamadaIa(c)]
        })
        if (!this.okRespuesta(data)) {
          this.$set(c, 'ia_estado', 'error')
          this.$set(c, '_iaLoading', false)
          return
        }
        const res = (data.resultados && data.resultados[0]) || null
        if (!res) {
          this.$set(c, 'ia_estado', 'error')
          this.$set(c, 'ia_error', 'Sin respuesta de IA')
          this.$set(c, '_iaLoading', false)
          return
        }
        this.aplicarResultadoIa(c, res)
        this.refrescarItemModalReporte()
        if (!res.ok) {
          this.iaIntencionError = res.error || 'No se pudo analizar la llamada'
        }
      } catch (e) {
        this.$set(c, 'ia_estado', 'error')
        this.$set(c, 'ia_error', this.mensajeHttp(e) || 'Error al analizar')
        this.$set(c, '_iaLoading', false)
        this.iaIntencionError = this.mensajeHttp(e) || 'Error al analizar con IA'
      }
    },
    async analizarIntencionesConIa () {
      const pendientes = this.intencionesPendientesIa
      if (!pendientes.length) return
      this.cargandoIaIntencion = true
      this.iaIntencionError = ''
      for (const c of pendientes) {
        this.$set(c, '_iaLoading', true)
        this.$set(c, 'ia_estado', 'processing')
      }
      try {
        const { data } = await telefoniaApi.analizarLoteIa({
          llamadas: pendientes.map((c) => this.payloadLlamadaIa(c))
        })
        if (!this.okRespuesta(data)) {
          for (const c of pendientes) {
            this.$set(c, 'ia_estado', 'error')
            this.$set(c, '_iaLoading', false)
          }
          return
        }
        const byKey = new Map()
        for (const r of data.resultados || []) {
          byKey.set(`${String(r.uniqueid).trim()}|${String(r.sucursal).trim()}`, r)
        }
        let fails = 0
        for (const c of pendientes) {
          const key = `${String(c.uniqueid).trim()}|${String(this.sucursalDeCdr(c)).trim()}`
          const res = byKey.get(key)
          if (!res) {
            this.$set(c, 'ia_estado', 'error')
            this.$set(c, 'ia_error', 'Sin resultado')
            this.$set(c, '_iaLoading', false)
            fails += 1
            continue
          }
          this.aplicarResultadoIa(c, res)
          if (!res.ok) fails += 1
        }
        this.refrescarItemModalReporte()
        if (fails) {
          this.iaIntencionError = `${fails} llamada(s) no se pudieron analizar. Revisa el detalle por fila.`
        } else {
          this.validarSuccess('Análisis IA completado')
        }
      } catch (e) {
        for (const c of pendientes) {
          this.$set(c, 'ia_estado', 'error')
          this.$set(c, '_iaLoading', false)
        }
        this.iaIntencionError = this.mensajeHttp(e) || 'Error al analizar con IA'
      } finally {
        this.cargandoIaIntencion = false
      }
    },
    seleccionarNumeroReal (num) {
      const n = num != null ? String(num).trim() : ''
      if (!n) return
      // Toggle: mismo número otra vez → deseleccionar
      this.reporteNumeroSeleccionado =
        this.reporteNumeroSeleccionado === n ? null : n
    },
    async cargarAsignacionesParaReporte () {
      this.cargarAsignacionesReporte = true
      try {
        const { data } = await this.$http.get('telefonia.sucursal.origen.list')
        this.asignacionesReporte = Array.isArray(data) ? data : []
        if (!this.asignacionesReporte.length) {
          this.validarError(
            'No hay asignaciones en Sucursal origen. Agrégalas para ver vendedoras en el reporte.'
          )
        }
      } catch (e) {
        this.asignacionesReporte = []
        this.validarError(this.mensajeHttp(e) || 'Error al cargar asignaciones')
      } finally {
        this.cargarAsignacionesReporte = false
      }
    },

    okRespuesta (data) {
      if (data && data.success === false) {
        const m = data.message || data.error || 'La operación no fue exitosa'
        this.validarErrorDirecto(typeof m === 'string' ? m : JSON.stringify(m))
        return false
      }
      return true
    },

    buildQuery (f) {
      const q = {}
      if (f.startDate) q.startDate = f.startDate
      if (f.endDate) q.endDate = f.endDate
      if (f.numRecords != null && f.numRecords !== '') q.numRecords = f.numRecords
      if (f.page != null && f.page !== '') q.page = f.page
      if (this.escuelaSeleccionada != null && this.escuelaSeleccionada !== '') {
        q.escuela = this.escuelaSeleccionada
      }
      if (this.idPlantelSeleccionado != null && this.idPlantelSeleccionado !== '') {
        const p = this.plantelesLista.find(
          (x) => String(x.id_plantel) === String(this.idPlantelSeleccionado)
        )
        if (p) {
          const s = this.sucursalDelPlantel(p)
          if (s) q.sucursal = s
        } else {
          console.warn('[TelefoniaDashboard] buildQuery: idPlantel no está en plantelesLista', {
            idPlantelSeleccionado: this.idPlantelSeleccionado,
            listaLength: this.plantelesLista.length
          })
        }
      }
      console.log('[TelefoniaDashboard] buildQuery → params API', {
        query: { ...q },
        idPlantelSeleccionado: this.idPlantelSeleccionado,
        plantelesCargados: (this.plantelesLista || []).length,
        idsPermitidosEscuela: (this.identificadoresSucursalEscuelaActual || []).slice(0, 30)
      })
      return q
    },

    /** ANSWERED vs NO ANSWER (y otros): colores para chip de disposition */
    colorChipDisposition (val) {
      const s = String(val || '').trim().toUpperCase()
      if (s === 'ANSWERED') return 'success'
      if (s === 'BUSY') return 'amber darken-2'
      if (s === 'NO ANSWER' || s.indexOf('NO ANSWER') !== -1) return 'error'
      return 'grey darken-1'
    },

    /** Iconos para el filtro de disposition (misma familia que la tabla). */
    iconoDisposition (d) {
      const s = String(d || '').trim().toUpperCase()
      if (s === 'ANSWERED') return 'mdi-phone-check'
      if (s === 'BUSY') return 'mdi-phone-clock'
      if (s === 'NO ANSWER' || s.indexOf('NO ANSWER') !== -1) return 'mdi-phone-missed'
      if (s === 'FAILED' || s.indexOf('FAIL') !== -1) return 'mdi-phone-hangup'
      if (s === 'CANCEL' || s.indexOf('CANCEL') !== -1) return 'mdi-phone-cancel'
      return 'mdi-phone-outline'
    },

    /** Inbound / Outbound: chip minimalista outlined */
    colorChipSentido (val) {
      const s = String(val || '').toLowerCase()
      if (s.indexOf('inbound') !== -1) return 'teal'
      if (s.indexOf('outbound') !== -1) return 'deep-orange'
      return 'grey'
    },

    etiquetaSentido (val) {
      if (val == null || String(val).trim() === '') return ''
      const s = String(val).toLowerCase()
      if (s.indexOf('inbound') !== -1) return 'Inbound'
      if (s.indexOf('outbound') !== -1) return 'Outbound'
      return String(val).trim()
    },

    async cargarCdrLista () {
      this.cdrError = ''
      this.cargarCdr = true
      try {
        const { data } = await telefoniaApi.getCdr(this.buildQuery(this.filtros))
        if (!this.okRespuesta(data)) return
        this.cdrRecords = Array.isArray(data.records) ? data.records : []
        this.cdrRaw = data.raw != null ? data.raw : null
        this.$nextTick(() => {
          const rec = this.cdrRecords || []
          const sucVals = [...new Set(rec.map((row) => String(row.sucursal != null ? row.sucursal : '')))].filter(Boolean)
          const fil = this.cdrRecordsFiltrados || []
          console.log('[TelefoniaDashboard] CDR: API vs tabla (filtro sucursal/escuela)', {
            recordsDesdeAPI: rec.length,
            filasMostradas: fil.length,
            escuelaSeleccionada: this.escuelaSeleccionada,
            idPlantelSeleccionado: this.idPlantelSeleccionado,
            sucursalesDistintasEnRecords: sucVals.slice(0, 20),
            identificadoresPermitidosEscuela: (this.identificadoresSucursalEscuelaActual || []).slice(0, 30),
            plantelesFiltradosPorEscuela: this.plantelesFiltradosPorEscuela.length
          })
          if (rec.length > 0 && fil.length === 0) {
            console.warn(
              '[TelefoniaDashboard] El API devolvió registros pero el filtro dejó 0 filas. Revisa escuela del plantel id en sucursal vs catálogo.',
              { primeraFila: rec[0] }
            )
          }
        })
      } catch (e) {
        this.cdrError = this.mensajeHttp(e)
        this.validarError(this.cdrError)
        console.error('[TelefoniaDashboard] getCdr error', e)
      } finally {
        this.cargarCdr = false
      }
    },

    async cargarEstadisticas () {
      this.statsError = ''
      this.stats = null
      this.sampleSize = null
      this.topExtensiones = []
      this.cargarStats = true
      try {
        const statsQuery = this.buildQuery(this.filtrosStats)
        console.log('[TelefoniaDashboard] getStats', { statsQuery })
        const { data } = await telefoniaApi.getStats(statsQuery)
        if (!this.okRespuesta(data)) return
        this.stats = data.stats || null
        this.sampleSize = data.sampleSize != null ? data.sampleSize : null
        const top = (this.stats && this.stats.topExtensiones) || []
        this.topExtensiones = Array.isArray(top) ? top : []
        console.log('[TelefoniaDashboard] getStats respuesta', {
          sampleSize: this.sampleSize,
          stats: this.stats
        })
      } catch (e) {
        this.statsError = this.mensajeHttp(e)
        this.validarError(this.statsError)
        console.error('[TelefoniaDashboard] getStats error', e)
      } finally {
        this.cargarStats = false
      }
    },

    async cargarExtensionesLista () {
      this.extError = ''
      this.extensionsData = null
      this.cargarExt = true
      try {
        const { data } = await telefoniaApi.getExtensions()
        if (!this.okRespuesta(data)) return
        this.extensionsData = data.data != null ? data.data : data
      } catch (e) {
        this.extError = this.mensajeHttp(e)
        this.validarError(this.extError)
      } finally {
        this.cargarExt = false
      }
    },

    async cargarEstadoSistema () {
      this.statusError = ''
      this.statusData = null
      this.cargarStatus = true
      try {
        const { data } = await telefoniaApi.getSystemStatus()
        if (!this.okRespuesta(data)) return
        this.statusData = data.data != null ? data.data : data
      } catch (e) {
        this.statusError = this.mensajeHttp(e)
        this.validarError(this.statusError)
      } finally {
        this.cargarStatus = false
      }
    },

    recargarPestañaActual () {
      if (this.tab === 0) this.cargarCdrLista()
      else if (this.tab === 1) this.cargarEstadisticas()
      else if (this.tab === 2) this.cargarExtensionesLista()
      else this.cargarEstadoSistema()
    }
  }
}
</script>

<style scoped>
.telefonia-filtros-vista {
  border: 1px solid rgba(0, 0, 0, 0.08);
}
.telefonia-filtros-chips {
  gap: 4px;
}
.telefonia-btn-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 28px;
  padding: 0 14px;
  border: none;
  border-radius: 9999px;
  color: #fff;
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1;
  cursor: pointer;
  box-shadow: none;
  transition: background 0.15s ease, box-shadow 0.15s ease;
}
/* Total: azul — información / panorama completo */
.telefonia-btn-pill--total {
  background: #1976d2;
}
.telefonia-btn-pill--total:hover {
  background: #1565c0;
}
.telefonia-btn-pill--total:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.35);
}
/* Reales: verde — acción concreta / números marcados */
.telefonia-btn-pill--reales {
  background: #2e7d32;
}
.telefonia-btn-pill--reales:hover {
  background: #1b5e20;
}
.telefonia-btn-pill--reales:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(46, 125, 50, 0.35);
}
/* Intención: naranja — atención / conversión / foco */
.telefonia-btn-pill--intencion {
  background: #ef6c00;
}
.telefonia-btn-pill--intencion:hover {
  background: #e65100;
}
.telefonia-btn-pill--intencion:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(239, 108, 0, 0.35);
}
@media (min-width: 960px) {
  .telefonia-filtro-sentido-col {
    border-left: 1px solid rgba(0, 0, 0, 0.08);
    padding-left: 20px !important;
  }
}
.ia-reporte-header {
  background: linear-gradient(135deg, #1a237e 0%, #283593 100%);
}
.ia-visto-bueno {
  border-radius: 10px;
  border: 1px solid transparent;
}
.ia-visto-bueno--ok {
  background: #e8f5e9;
  border-color: #a5d6a7;
  color: #1b5e20;
}
.ia-visto-bueno--warn {
  background: #fff8e1;
  border-color: #ffe082;
  color: #e65100;
}
.ia-retro-text {
  line-height: 1.65;
  white-space: pre-wrap;
}
.telefonia-link-vendedora {
  background: none;
  border: none;
  padding: 0;
  color: #1565c0;
  font-weight: 600;
  cursor: pointer;
  text-align: left;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.telefonia-link-vendedora:hover {
  color: #0d47a1;
}
.ia-vendedora-card {
  overflow: hidden;
  border-radius: 12px;
}
.ia-vendedora-header {
  background: linear-gradient(135deg, #2e7d32 0%, #43a047 100%);
}
.ia-promedio-badge {
  min-width: 72px;
  border-radius: 50%;
  padding: 10px 6px;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.ia-promedio-badge--empty {
  background: #eceff1;
  border: 2px dashed #b0bec5;
}
.ia-promedio-num {
  font-size: 1.75rem;
  font-weight: 800;
  line-height: 1;
}
.ia-promedio-label {
  font-size: 0.7rem;
  opacity: 0.95;
  margin-top: 2px;
}
.ia-punto-mejora {
  background: #fff8e1;
  border: 1px solid #ffe082;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 0.875rem;
  line-height: 1.4;
  color: #5d4037;
}
</style>
